"use strict";
import _ from "lodash";
import moment from "moment";

export const DATE_ADDED_END_FILTER = {
    func: function (element, test) {
        return moment(element.growerMembership.created).isSameOrBefore(test);
    },
};
export const DATE_ADDED_START_FILTER = {
    func: function (element, test) {
        return moment(element.growerMembership.created).isSameOrAfter(test);
    },
};
export const WORKER_STATUS_FILTER = {
    func: function (element, test) {
        let activeValue = _.get(element.growerMembership, "active", false);
        if (test === "active") {
            return activeValue;
        } else if (test === "inactive") {
            return !activeValue;
        } else if (test === "all") {
            return true;
        }
    },
};
export const DOCUMENT_STATUS_FILTER = {
    func: function (element, test) {
        if (test === "incomplete") {
            return !_.isEmpty(element.incompletePaperworkRequests);
        } else if (test === "complete") {
            return _.isEmpty(element.incompletePaperworkRequests);
        }
    },
};

export function filtered(collection, filters, filterConfig) {
    collection = _.filter(collection, function (member) {
        let x = [];
        _.forEach(filters, function (value, key) {
            let filter = filterConfig[key];
            if (filter && value) {
                x.push(filter.func(member, value));
            }
        });
        return _.every(x);
    });
    return collection;
}

export const MOBILE_STATUS_FILTER = {
    func: function (element, test) {
        if (test === "none") {
            return _.isNil(element.user.mobile);
        } else {
            return element.user.mobile_status === test;
        }
    },
};

export const CREW_FILTER = {
    func: function (element, test) {
        if (_.isEmpty(test)) {
            return true;
        }

        return !_.isEmpty(
            _.intersection(_.map(element.memberships, "group"), test),
        );
    },
};

/**
 * AngularJS filter to convert URLs in text to clickable links
 * @param {string} text - The text that may contain URLs
 * @returns {string} HTML string with URLs converted to anchor tags
 */
export function linkifyFilter($sce) {
    "ngInject";
    return function (text) {
        if (!text) return text;

        // Regular expression to match URLs
        // This pattern matches http://, https://, ftp://, www., and basic domain patterns
        const urlRegex =
            /(https?:\/\/[^\s<>"]+|ftp:\/\/[^\s<>"]+|www\.[^\s<>"]+|[a-zA-Z0-9][a-zA-Z0-9-]*[a-zA-Z0-9]*\.[a-zA-Z]{2,}[^\s<>"]*)/gi;

        const linkedText = text.replace(urlRegex, function (url) {
            // Clean up the URL by removing trailing punctuation
            const cleanUrl = url.replace(/[.,;:!?)"']*$/, "");

            // If the URL doesn't start with a protocol, add http://
            let href = cleanUrl;
            if (!cleanUrl.match(/^https?:\/\/|^ftp:\/\//)) {
                href = "http://" + cleanUrl;
            }

            // Create the anchor tag with appropriate styling and security attributes
            return `<a href="${href}" target="_blank" rel="noopener noreferrer" class="text-harvustorange underline">${cleanUrl}</a>`;
        });

        // Return trusted HTML so it can be used with ng-bind-html
        return $sce.trustAsHtml(linkedText);
    };
}
